import type { PrefetchContext, PrefetchedDataProps } from 'src/shared/prefetch';

import { useCountryCode, useLocale } from 'src/app/shared/hooks/l10n';
import { useCurrentUserId } from 'src/app/shared/hooks/session';

import { prefetchPetitionUpdatePageDataFromApi, usePetitionUpdatePageDataFromApi } from './pageData';

export type PetitionUpdatePagePrefetchedContext = Readonly<{
	pageData: NonNullable<Parameters<typeof usePetitionUpdatePageDataFromApi>[0]>;
}>;

export type PetitionUpdatePageCombinedState = ReturnType<typeof usePetitionUpdatePageDataFromApi>;

export function usePageContext(
	petitionSlugOrId: string,
	updateId: string,
	prefetchedData?: PetitionUpdatePagePrefetchedContext,
): PetitionUpdatePageCombinedState {
	const userId = useCurrentUserId();
	const locale = useLocale();
	const countryCode = useCountryCode();
	return usePetitionUpdatePageDataFromApi(prefetchedData?.pageData, {
		petitionSlugOrId,
		updateId,
		userId,
		locale,
		countryCode,
	});
}

export async function prefetchPageContext(
	petitionSlugOrId: string,
	updateId: string,
	context: PrefetchContext,
): Promise<PetitionUpdatePagePrefetchedContext> {
	const pageData = await prefetchPetitionUpdatePageDataFromApi(context, {
		petitionSlugOrId,
		updateId,
		userId: context.session?.user?.id,
		...context.l10n,
	});

	return { pageData };
}

export type PetitionUpdatePagePrefetchedDataProps = PrefetchedDataProps<PetitionUpdatePagePrefetchedContext>;
